if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

//Funcionality to Lazyloading opentable
let open_widget = document.querySelector('.bg-quad__text .current_widget');
if(open_widget){
    setTimeout(() => {
        open_widget.style.display = 'flex';
    }, 2000);
}
    

(function(){

    $('#enews-handle, .enews__close, .signup__trigger').click(function(e){
        e.preventDefault();
        $('#enews-handle').toggleClass('open');
        $('.enews').toggleClass('open');
    });

    //event get info member by id -> Blog Entry
    $(".mgt-team__unit").click(function(e){
        e.preventDefault()
        let entryId = $(this).data('id')
        $('.member-info').fadeOut();
        $.post(site_url+"ajax/functions.php",{operation: 'getBlogEntryData', entryId: entryId},function(data){
            if(data.result==='success'){
                $('#itemTitle').html(data.entry.title);
                $('#itemSubtitle').html(data.entry.subtitle);
                $('#itemContent').html(data.entry.content);
                $('.member-info__photo').css('backgroundImage',`url(${data.secondImage})`);
                $('.member-info').fadeIn(400);
            }
        }, "json");
    });

    $('.accordion__unit-button').click(function(e){
        e.preventDefault();
        $(this).siblings('.accordion__unit-copy').slideToggle();
    });

    // lighbox gift-cards functionality
    let buttonGiftCard = document.querySelector('#button-card');
    buttonGiftCard.addEventListener('click', e => {
        let dropdownGiftCard = document.querySelector('#gift-select');
        buttonGiftCard.setAttribute('href', dropdownGiftCard.value);
    });

    //Event get info job
    // $('.job-info .back').click(function(e){
    //     e.preventDefault();
    //     $('.jobs.container').fadeIn();
    //     $('.job-info').fadeOut(); 
    // });
    // $('.jobs__unit-button').click(function(e){
    //     e.preventDefault()
    //     let entryId = $(this).data('id');
    //     $('.jobs.container').fadeOut();
    //     $('.job-info').fadeOut();
    //     $.post(site_url+"ajax/functions.php",{operation: 'getBlogEntryData', entryId: entryId},function(data){
    //         if(data.result==='success'){
    //             $('#jobTittle').html(data.entry.title);
    //             $('#jobContent').html(data.entry.content);
    //             $('.job-info').fadeIn(400);
    //         }
    //     }, "json");
    // });

    //Close model
    $(".member-info__close").click(function(e){
        $('.member-info').fadeOut(400);
    });
    
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    $('.slider-info').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    dots: true,
                }
            }
        ]
    });

})();